import React, {FC} from "react";

interface ruleProps {
    text: string
}

export const PackageRulesTextNormal: FC<ruleProps> = ({text}) => {
    if (!text) {
        return null;
    }
    return (
        <div className={"packages_rules_item text_normal"}>{text}</div>
    )
}